import type { UserStateMap } from "../../types/user-state";
import { isSavedSearchFolderKey, isSavedSearchKey } from "../../types/user-state";

/** A savedSearch# item as stored in UserState (spec §3.2), flattened for the UI. */
export interface ServerSavedSearch {
  id: string;
  url: string;
  label?: string;
  alertEnabled: boolean;
  createdAt?: number;
  folderId?: string;
  order?: number;
  version: number;
}

export function parseServerSavedSearches(userState: UserStateMap): ServerSavedSearch[] {
  const result: ServerSavedSearch[] = [];
  for (const [itemKey, entry] of Object.entries(userState)) {
    if (!isSavedSearchKey(itemKey)) continue;
    const data = entry.data ?? {};
    const url = data.url;
    if (typeof url !== "string" || url.trim().length === 0) continue;
    result.push({
      id: itemKey.slice("savedSearch#".length),
      url,
      ...(typeof data.label === "string" && data.label.trim() ? { label: data.label } : {}),
      alertEnabled: data.alertEnabled === true,
      ...(typeof data.createdAt === "number" ? { createdAt: data.createdAt } : {}),
      ...(typeof data.folderId === "string" && data.folderId.trim() ? { folderId: data.folderId } : {}),
      ...(typeof data.order === "number" ? { order: data.order } : {}),
      version: entry.version,
    });
  }
  return result;
}

/** A savedSearchFolder# item as stored in UserState, flattened for the UI. */
export interface ServerSavedSearchFolder {
  id: string;
  name: string;
  order: number;
  createdAt?: number;
  version: number;
}

export function parseServerSavedSearchFolders(userState: UserStateMap): ServerSavedSearchFolder[] {
  const result: ServerSavedSearchFolder[] = [];
  for (const [itemKey, entry] of Object.entries(userState)) {
    if (!isSavedSearchFolderKey(itemKey)) continue;
    const data = entry.data ?? {};
    const name = data.name;
    if (typeof name !== "string" || name.trim().length === 0) continue;
    result.push({
      id: itemKey.slice("savedSearchFolder#".length),
      name,
      order: typeof data.order === "number" ? data.order : 0,
      ...(typeof data.createdAt === "number" ? { createdAt: data.createdAt } : {}),
      version: entry.version,
    });
  }
  return result;
}
